const Images = {
  logo: require("./nobel_logo.png"),
  hero_img: require("./hero_img.png"),
  home: require("./home_logo.png"),
  footer: require("./footer_background.jpg"),
  testimonial: require("./testimonial.jpg"),
  faq: require("./FAQs-cuate.png"),
  innovation_logo: require("./innovationhub.png"),
  microsoft_logo: require("./microsoft_logo.png"),
  innovationboost_logo: require("./innovationboost_logo.png"),
  brock_logo: require("./brock_logo.jpg"),
  legalzone_logo: require("./legalzone_logo.png"),
  vector_logo: require("./vectorinstitute_logo.png"),
  unfc_logo: require("./unfc_logo.png"),
  herzing_logo: require("./herzingcollege_logo.jpg"),
  about_us: require("./about_us.png"),
  login_image: require("./login_image.jfif"),
  home_img: require("./home_img.png"),
  testimonial_img1: require("./testimonial1.png"),
  testimonial_img2: require("./testimonial2.png"),
  testimonial_img3: require("./testimonial3.png"),
};

export default Images;
